module.exports = __webpack_public_path__ + "img/ext8.2ab45fd3.png";